import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HuvudB2 } from '../../interfaces/huvudB2.interface';
import { HuvudB2Service } from './huvud-b2.service';
import { AttestService } from '../../attest/attest.service';
import { fadeInAnimation } from '../../_animations/fade-in.animation';
import { Router, ActivatedRoute } from '@angular/router';
import { Attest } from '../../interfaces/attest.interface';
import { SessionService } from '../../session/session.service';

@Component({
    selector: 'app-huvud-b2',
    templateUrl: './huvud-b2.component.html',
    styleUrls: ['./huvud-b2.component.scss'],
    animations: [
        fadeInAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HuvudB2Component {

  constructor(
    protected service: HuvudB2Service,
    protected spinner: NgxSpinnerService,
    protected sessionService: SessionService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected attestService: AttestService) {
    const huvudB2Id = this.route.snapshot.paramMap.get('id');
    this.loadHuvudB2(huvudB2Id);
  }

  public get isLoaded(): boolean { return !!this.huvudB2; };
  public get role(): string { return this.sessionService.activeInstance.name; };

  public userFilter: any;

  public applyFilter() {
    const filterNumber: string = '' + (+this.filterText.replace(/[ .,]/g, ''));

    this.userFilter = {
      $or: [
        {
          anstallning: {
            arbetstagare: {
              $or: [
                { fornamn: this.filterText },
                { efternamn: this.filterText },
                { personNr12Siffror: this.filterText }
              ]
            }
          }
        },
        { lgBeloppTotal_cache: filterNumber },
        { fordranBeloppTotal_cache: filterNumber }
      ]
    }
  }

  public activated: boolean = false;

  public orderName: string = 'personNr';
  public order: string[] = [ 'anstallning.arbetstagare.personNr12Siffror' ];
  public filterText: string;
  public reverse: boolean = false;

  public huvudB2: HuvudB2;

  private loadHuvudB2(id: string): void {

    const doLoad = () => {
      setTimeout(() => {
        if (!this.huvudB2) {
          this.spinner.show();
        }
      }, 300);

      this.service.getHuvudB2(this.sessionService.activeInstance.id, id).subscribe(
        result => {
          this.spinner.hide();
          this.huvudB2 = result;

          this.huvudB2.b2Beslut.forEach(b => {
            b.anstallning.isConfidential = b.anstallning.arbetstagare.fornamn.indexOf('SEKRETESS') !== -1;
          });
        },
        () => {
          this.spinner.hide();
        });
    }

    if (!this.sessionService.hasSession) {
      this.router.navigate(['/login']);
      return;
    }

    if (!this.sessionService.hasActiveInstance) {
      this.sessionService.selectInstance(doLoad);
      return;
    }

    doLoad();
  }

  public attestHuvudB2(): void {

    this.spinner.show();

    this.attestService.attestManyArendeBeslut(this.sessionService.activeInstance.id, this.huvudB2.arende.id, [this.huvudB2.id]).subscribe(
      (attest: Attest) => {
        this.huvudB2.attest = attest;
        this.huvudB2.harAttest = !!attest;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
      });
  }

  public get instanceName() {
    return this.sessionService.activeInstance.name;
  }

  public setOrder(name: string, order: string[]): void {
    if (this.orderName === name) {
      this.reverse = !this.reverse;
    }

    this.orderName = name;
    this.order = order.slice();
  }

  public getSum(items: number[], property: string): number {
    let sum: number = 0;
    for (let i = 0; i < items.length; i++) {
      sum += items[i][property] as number || 0;
    }

    return sum;
  }
}
